<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-btn color="blue" @click="dialog = true">عمل مرتجع عام </v-btn>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <!-- <template v-slot:activator="{ on }">
          <v-btn color="primary" dark @click="newFatwora">عمل فاتورة وتحويلها لقيد التنفيذ</v-btn>
        </template> -->
        <v-card>
          <v-toolbar dark color="orange">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>اغلاق</v-toolbar-title>
            <v-toolbar-title>اضافة مرتجع عام لعميل</v-toolbar-title>
            <v-divider class="mx-2" inset vertical></v-divider>
            <p style="color:yellow">
              هذا المرتجع يستخدم في حالة عدم وجود فاتورة بيع اصلية
            </p>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="dialog = false">حفظ</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-card>
              <div>
                <div style="direction:rtl">
                  <v-card-text>
                    <v-form ref="form">
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <!-- <v-flex xs12 sm6 md1>
                    <v-text-field height=10 outline disabled v-model="mycode" label="كود الفاتورة" v-validate="'required'"
                        :error-messages="errors.collect('form1.code')" data-vv-name="code" data-vv-scope="form1" ></v-text-field>
                  </v-flex> -->

                          <v-flex xs12 sm6 md1>
                            <v-text-field
                              outline
                              disabled
                              v-model="select_client.code"
                              label="كود العميل "
                              v-validate="'required'"
                              :error-messages="errors.collect('form1.price')"
                              data-vv-name="name"
                              data-vv-scope="form1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-autocomplete
                              outline
                              v-model="select_client"
                              :items="clients"
                              :hint="
                                `${
                                  select_client.mandob_sales
                                    ? select_client.mandob_sales.name
                                    : ''
                                }- ${
                                  select_client.mohafza
                                    ? select_client.mohafza.name
                                    : ''
                                }- ${
                                  select_client.city
                                    ? select_client.city.name
                                    : ''
                                }- ${
                                  select_client.region
                                    ? select_client.region.name
                                    : ''
                                }- ${
                                  select_client.branch
                                    ? select_client.branch.name
                                    : ''
                                }`
                              "
                              item-text="name"
                              item-value="id"
                              label="أختر العميل "
                              persistent-hint
                              return-object
                              single-line
                              v-validate="'required'"
                              :error-messages="errors.collect('form1.manger')"
                              data-vv-name="manger"
                              data-vv-scope="form1"
                            >
                              <template v-slot:append-outer>
                                <v-slide-x-reverse-transition mode="out-in">
                                </v-slide-x-reverse-transition>
                              </template>
                            </v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              disabled
                              :value="
                                select_client.mandob_sales &&
                                select_client.mandob_sales_id != ''
                                  ? select_client.mandob_sales.name
                                  : ''
                              "
                              label="مندوب المبيعات"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md1>
                            <v-text-field
                              disabled
                              outline
                              v-model="select_client.rasid_efttahi"
                              label="الافتتاحي"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-autocomplete
                              outline
                              v-model="select_store"
                              :items="stores"
                              item-text="name"
                              item-value="id"
                              label="أختر المخزن "
                              persistent-hint
                              return-object
                              single-line
                              v-validate="'required'"
                              :error-messages="errors.collect('form1.manger')"
                              data-vv-name="manger"
                              data-vv-scope="form1"
                            >
                              <template v-slot:append-outer>
                                <v-slide-x-reverse-transition mode="out-in">
                                </v-slide-x-reverse-transition>
                              </template>
                            </v-autocomplete>
                          </v-flex>

                          <v-flex xs12 sm6 md2>
                            <v-dialog
                              ref="dialog2"
                              v-model="modal2"
                              :return-value.sync="date2"
                              persistent
                              lazy
                              full-width
                              width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="date2"
                                  label=" التاريخ اليدوي"
                                  readonly
                                  outline
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="date2" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn
                                  flat
                                  color="primary"
                                  @click="modal2 = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  flat
                                  color="primary"
                                  @click="$refs.dialog2.save(date2)"
                                  >OK</v-btn
                                >
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>

                          <v-flex xs12 sm6 md5>
                            <v-autocomplete
                              v-if="!is_edit"
                              v-model="select_item"
                              :items="m_items"
                              item-text="name"
                              item-value="id"
                              label="أختر الصنف"
                              persistent-hint
                              prepend-icon="mdi-city"
                              return-object
                            >
                              <template v-slot:append-outer>
                                <v-slide-x-reverse-transition mode="out-in">
                                </v-slide-x-reverse-transition>
                              </template>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              :disabled="select_item.id == ''"
                              type="number"
                              v-model="item_num_reback"
                              label="العدد"
                              @change="
                                check_max(
                                  item_num,
                                  select_item.store_item.quantity
                                )
                              "
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              :disabled="select_item.id == ''"
                              type="number"
                              v-model="item_bonus"
                              label="البونص"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              disabled
                              v-model="get_item_num_after"
                              label="العدد بعد"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              :disabled="select_item.id == ''"
                              type="number"
                              v-model="price"
                              label="السعر"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              disabled
                              v-model="gettotalpriceitem"
                              label="السعر الكلي"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              :disabled="select_item.id == ''"
                              type="number"
                              v-model="item_discount"
                              label="الخصم المرتجع"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              disabled
                              v-model="get_item_final_price"
                              label="السعر النهائي للصنف"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-btn
                              v-if="!is_edit"
                              color="orange"
                              :disabled="select_item.id == ''"
                              @click="add_item"
                              >اضف الصنف</v-btn
                            >
                          </v-flex>
                        </v-layout>
                        <v-divider class=" my-1" inset horizontal></v-divider>
                        <v-divider class=" my-1" inset horizontal></v-divider>

                        <v-data-table
                          :headers="headers"
                          :items="added_items"
                          class="elevation-1"
                          :search="search"
                          :loading="loading"
                          :rows-per-page-items="rowsPerPageItems"
                        >
                          <template slot="items" slot-scope="props">
                            <td>
                              <v-btn
                                style="width: 50px;"
                                @click="remove_item(props.item)"
                                ><v-icon>delete</v-icon></v-btn
                              >
                            </td>
                            <td>{{ props.item.item_name }}</td>
                            <td>{{ props.item.item_num_reback }}</td>
                            <td>{{ props.item.price }}</td>
                            <td>{{ props.item.total_price }}</td>
                            <td>{{ props.item.item_num_before }}</td>
                            <td>{{ props.item.item_discount }}</td>
                            <td>{{ props.item.item_bonus }}</td>
                            <td>{{ props.item.item_num_after }}</td>
                            <td>{{ props.item.final_price }}</td>
                          </template>
                        </v-data-table>

                        <v-layout>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              disabled
                              v-model="fatwora_price"
                              label="السعر الاجمالي للفاتورة "
                              v-validate="'required'"
                              :error-messages="errors.collect('form1.price')"
                              data-vv-name="name"
                              data-vv-scope="form1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              v-model="newItem.reback_discount"
                              label=" الخصم المرتجع "
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md2>
                            <v-text-field
                              outline
                              disabled
                              v-model="fatwora_final_price"
                              label=" السعر النهائي للفاتورة  "
                              v-validate="'required'"
                              :error-messages="
                                errors.collect('form1.fatwora_final_price')
                              "
                              data-vv-name="fatwora_final_price"
                              data-vv-scope="form1"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close"
                      >الغاء</v-btn
                    >
                    <v-btn color="blue darken-1" flat @click="save('form2')"
                      >حفظ</v-btn
                    >
                  </v-card-actions>
                  <v-layout> </v-layout>
                </div>
              </div>
            </v-card>
          </v-list>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  add_client_fatwora_reback,
  items_of,
  items_of_specific_order,
  search_client_by_code,
  reject_order,
  orders_and_fatwora_page,
  RebackSellAll
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,
    detail_dialog: false,
    order_detail: {},
    order_detail_to_fatwora: {},
    select_mandob_tawzi3: {},
    mandobs_tawzi3: [],

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    select_sadad_type: { id: "" },
    select_client: { id: "" },
    select_employer: { id: "" },
    select_store: { id: "" },
    select_item: { id: "" },
    select_sadadstatuses: { id: "" },

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "حذف ",
        align: "right",
        sortable: false
      },
      {
        text: "الصنف ",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: "العدد", value: "phone", sortable: false, align: "right" },
      { text: " السعر", value: "price", sortable: false, align: "right" },
      {
        text: " السعر الكلي",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: "  العدد قبل",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: "  الخصم",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " البونص ",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " العدد بعد ",
        value: "total_price",
        sortable: false,
        align: "right"
      },
      {
        text: " السعر النهائي",
        value: "total_price",
        sortable: false,
        align: "right"
      }
    ],

    headers2: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "اسم العميل", value: "client_name", align: "right" },
      { text: " السعر", value: "price", align: "right" },
      { text: "  المندوب", value: "emp_create_order", align: "right" },
      { text: "  التاريخ ", value: "taslim_date", align: "right" },
      { text: "  التفاصيل", value: "", sortable: false, align: "right" },
      { text: "  التحكم", value: "", sortable: false, align: "right" }
      // { text: "فاتورة جديدة", value: "", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      { text: " السعر", value: "price", sortable: false, align: "right" },
      {
        text: "  السعر الكلي",
        value: "emp_create_order",
        sortable: false,
        align: "right"
      }
    ],
    headers5: [
      {
        text: "حذف ",
        align: "right",
        value: "code"
      },
      { text: "الصنف ", value: "price_after", align: "right" },
      { text: "العدد", value: "client_name", align: "right" },
      { text: "السعر", value: "taslim_date", align: "right" },
      { text: "السعر الكلي", value: "taslim_date", align: "right" },
      { text: " العدد قبل", value: "store", sortable: false, align: "right" },
      { text: " خصم", value: "store", sortable: false, align: "right" },
      { text: " بونص", value: "store", sortable: false, align: "right" },
      { text: "السعر النهائي", value: "store", sortable: false, align: "right" }
    ],
    orders: [],
    order: {},
    fatworas: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    madionia_sabqa_of_madionia: "",
    newItem: {
      code: "",
      madionia_sabqa: "",
      madionia_now: "",
      reback_discount: "",
      price_before: "",
      price_after: "",
      store_id: "",
      sadad_type_id: "",
      client_id: "",
      emp_sales_response_id: "",
      created_at: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: ""
    },
    added_items: [],
    item_num_before: "",
    item_num_reback: "",
    item_num_after: "",
    item_discount: "",
    item_bonus: "",
    price: "",
    total_price: "",
    final_price: "",
    is_edit: false,
    items_of_old_fatwora: [],
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    mycode() {
      if (this.fatworas.length > 0) {
        return (this.code =
          parseInt(this.fatworas[this.fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    gettotalpriceitem() {
      if (this.item_num_reback != "" && this.price != "") {
        this.total_price =
          parseInt(this.item_num_reback) * parseFloat(this.price);
        return this.total_price;
      } else {
        return (this.total_price = 0);
      }
    },
    get_item_num_after() {
      if (
        this.item_bonus != 0 &&
        this.item_bonus != null &&
        this.item_bonus != ""
      ) {
        this.item_num_after =
          parseInt(this.item_num_reback) + parseFloat(this.item_bonus);
        return this.item_num_after;
      } else if (this.item_num != "") {
        return (this.item_num_after = parseInt(this.item_num_reback));
      } else {
        return (this.item_num_after = 0);
      }
    },
    get_item_final_price() {
      if (
        this.item_discount != "" &&
        this.item_discount != null &&
        this.item_discount
      ) {
        this.final_price =
          parseFloat(this.total_price) + parseFloat(this.item_discount);
        return this.final_price;
      } else if (this.total_price != "") {
        return (this.final_price = this.total_price);
      } else {
        return (this.final_price = 0);
      }
      return (this.final_price = parseFloat(this.total_price));
    },

    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].final_price);
      }
      return (this.newItem.price_before = tot_price);
    },
    fatwora_final_price() {
      if (
        this.newItem.price_before != "" &&
        this.newItem.reback_discount != ""
      ) {
        return (this.newItem.price_after =
          parseFloat(this.newItem.price_before) +
          parseFloat(this.newItem.reback_discount));
      }
      return (this.newItem.price_after = this.newItem.price_before);
    },
    madionia_now() {
      if (this.newItem.price_after > 0) {
        return (this.newItem.madionia_now =
          parseFloat(this.newItem.madionia_sabqa) +
          parseFloat(this.newItem.price_after));
      }
      return (this.newItem.madionia_now = this.newItem.madionia_sabqa);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    // this.initialize()

    orders_and_fatwora_page().then(response => {
      this.mandobs_tawzi3 = response.data.mandobs_tawzi3;
      this.m_sadad_types = response.data.sadadtypes;
      this.m_employers = response.data.employers;
      this.clients = response.data.clients;
      this.stores = response.data.stores;
      this.sadadstatuses = response.data.sadadstatuses;
      this.orders = response.data.orders;
      this.m_items = response.data.items;

      this.pagination.totalItems = response.data.fatworas.length;
      this.loading = false;
    });

    RebackSellAll().then(res => {
      this.fatworas = res.data.myarr;
    });

  },

  methods: {
    check_max(item, q) {
      //  let index = this.client_fatwora_reback_items.indexOf(item);
      if (parseInt(item) > parseInt(q)) {
        alert("لا يجوز ادخال قيمة اكبر من العدد المتاح");
        this.item_num = q;
      }
      if (parseInt(item) < 0) {
        alert("لا يجوز ادخال قيمة اقل من الواحد ");
        this.item_num = 1;
      }
    },
    initialize() {},

    get_items_of_store() {
      this.loading = true;
      this.items_of_old_fatwora = [];
      if (this.is_edit) {
        var frmData = new FormData();
        frmData.append("items", JSON.stringify(this.added_items));
        items_of_specific_order(this.select_store.id, frmData).then(
          response => {
            this.items_of_old_fatwora = response.data;
            this.loading = false;
          }
        );
      } else {
        items_of(this.select_store.id).then(response => {
          this.m_items = response.data;
          this.loading = false;
        });
      }
    },

    add_item() {
      if (this.select_item.name) {
        this.added_items.push({
          item_name: this.select_item.name,
          item_num_before: "",
          item_num_reback: this.item_num_reback,
          item_num_remain: "",
          item_discount: this.item_discount,
          item_bonus: this.item_bonus,
          item_num_after: this.item_num_after,
          price: this.price,
          total_price: this.total_price,
          final_price: this.final_price,
          item_id: this.select_item.id
        });
        this.select_item = { id: "" };
        this.item_num_before = "";
        this.item_num_reback = "";
        this.item_num_after = "";
        this.item_discount = "";
        this.item_bonus = "";
        this.price = "";
        this.total_price = "";
        this.final_price = "";
      }
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    change_sadad_name() {
      this.newItem.sdad_type_name = this.select_sadad_type.name;
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.select_client.id != "" &&
          this.select_store.id != ""
        ) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.client_id = this.select_client.id;
          this.newItem.store_id = this.select_store.id;
          this.newItem.created_at = this.date2;
          this.newItem.status = 0;
          this.newItem.emp_sales_response_name = myUser.name;
          this.newItem.emp_sales_response_id = myUser.id;
          this.newItem.fatwora_id = "0";
          this.newItem.madionia_now = this.madionia_now;

          this.madionia.madionia_before = this.madionia_sabqa_of_madionia;
          this.madionia.cost_or_money = this.newItem.price_after;
          this.madionia.madionia_after =
            parseFloat(this.madionia_sabqa_of_madionia) +
            parseFloat(this.newItem.price_after);
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "reback";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.client_id = this.select_client.id;
          this.madionia.emp_id = myUser.id;

          var frmData = new FormData();
          frmData.append("client_fatwora_reback", JSON.stringify(this.newItem));
          frmData.append(
            "fatwora_reback_items",
            JSON.stringify(this.added_items)
          );
          frmData.append("madionia", JSON.stringify(this.madionia));
          this.order_detail_to_fatwora.id
            ? frmData.append("order_id", this.order_detail_to_fatwora.id)
            : "";

          add_client_fatwora_reback(frmData).then(response => {
            // setInterval(() => {
            //   this.printDiv("printMe");
            // }, 1000);
            this.$router.push("/FatworaRebackDetailByID/" + response.data.id);
          });
        }
      });
    },

    search_client_by_code() {
      search_client_by_code(this.client_search_name).then(response => {
        this.select_client = response.data;
      });
    },
    detailItem(order) {
      this.order_detail = order;
      this.detail_dialog = true;
    },
    confirm_order(order) {
      this.order_detail_to_fatwora = order;
      this.dialog = true;
      // this.newFatwora();
      // confirm_order(order.id).then(response => {
      //   Vue.set(
      //     this.orders,
      //     this.orders.findIndex(f => f.id === order.id),
      //     response.data
      //   );
      // });
    },
    reject_order(order) {
      reject_order(order.id).then(response => {
        Vue.set(
          this.orders,
          this.orders.findIndex(f => f.id === order.id),
          response.data
        );
      });
    },

    newFatwora() {
      this.order_detail_to_fatwora = {};
      let myUser = JSON.parse(localStorage.getItem("user"));
      this.dialog = true;
      this.added_items = [];
      this.select_client = { id: "" };
      this.newItem.created_at = "";
      this.newItem.madionia_sabqa = "";
      this.newItem.madionia_now = "";
      this.newItem.price = "";
      this.newItem.final_price = "";
      // this.newItem.emp_sales_response_id = myUser.id;
      this.is_edit = false;
    },

    printDiv(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;

      document.body.classList.add("rtl");
      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
      return true;
    }
  }
};
</script>

<style scoped>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
.custom-btn {
  padding: 0px;
  margin: 0px;
  width: 5px !important;
}
.v-input__control {
  height: 62px;
}
/* 
@media print {
  body * {
    visibility: hidden;
  }
  .printMe,
  .printMe * {
    visibility: visible;
  }
  .printMe {
     width: 100%; 
    position: absolute;
    left: 0;
    top: 0;
  }
}
    */
.rtl {
  direction: rtl !important;
  text-align: right !important;
}
.head_p {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline;
}
</style>
